/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-filter[_ngcontent-%COMP%], .box-parent[_ngcontent-%COMP%] {\n  background: #FFFFFF;\n  padding: 1.5em 2em 20px 2em !important;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.box-parent[_ngcontent-%COMP%] {\n  border-radius: 0 0 10px 10px; }\n\n.progress-text[_ngcontent-%COMP%] {\n  font-weight: 500;\n  color: #AF3694; }\n\n.p-b-15[_ngcontent-%COMP%] {\n  padding-bottom: 15px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-list/billing-list.component.scss.shim.ngstyle.js.pre-build-optimizer.js